import * as types from '@/store/mutation-types'
import store from '@/store'

// CommonJS 방식
// exports.WebUtil = {

// ES 모듈방식
export const WebUtil = {

    /**
     * null 체크
     * str : 문자열
     */
    isNull: function(str) {
        var type = typeof str;

        if (type === "undefined" || str === null) {
            return true;
        }

        if (type === "string" && this.trim(str) == "") {
            return true;
        }

        return false;
    },

    /**
     * not null 체크
     * str : 문자열
     */
    isNotNull: function(str) {
        return !this.isNull(str);
    },

    /**
     * object 체크
     * obj : 오브젝트
     */
    isObject: function(obj) {
        if ( obj !== null && typeof obj === "object" ) {
            return true;
        }

        return false;
    },

    /**
     * 숫자 체크 체크
     * num : 숫자
     */
    isNumber: function(num) {
        var regex = /^[0-9]+$/;
        return regex.test(num);
    },

    /**
     * 좌우 공백제거
     * str : 문자열
     */
    trim: function(str) {
        if (typeof str === "string") {
            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        }

        return str;
    },

    /**
     * null 값 바꾸기
     * str : 문자열
     * val : null 대체값
     */
    nvl: function(str, val) {
        if (this.isNull(str)) {
            return val;
        }

        return this.trim(str);
    },

    /**
     * 전체 치환
     * str     : 문자열
     * pattern : 패턴
     * re      : 치환될 문자
     */
    replaceAll: function(str, pattern, re) {
        var type = typeof str;

        if (type === "string" || type === "number") {
            var temp = this.trim(str) + "";

            if (temp != "") {
                return temp.replace(new RegExp(pattern, "g"), re);
            }
        }

        return str;
    },

    /**
     * 천단위 콤마 추가
     * str : 숫자, 문자열
     */
    addThousandComma: function(str) {
        var type = typeof str;

        if (type === "string" || type === "number") {
            var temp = this.trim(str) + "";

            if (temp != "") {
                return temp.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }

        return str;
    },

    /**
     * 이메일 체크
     * str : 문자열
     */
    isValidEmail: function(str) {
        if (typeof str === "string") {
            var pattern = /^[0-9a-z]([-_\.]?[0-9a-z])*@[0-9a-z]([-_\.]?[0-9a-z])*\.[a-z]{2,3}$/i;

            if (pattern.test(str)) {
                return true;
            }
        }

        return false;
    },

    /**
     * 엔터 BR 변환
     * str : 문자열
     */
    enterToBr: function(str) {
        if (typeof str === "string") {
            return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
        }

        return str;
    },

    /**
     * URL Param 파싱
     */
    getUrlParams: function() {
        var params = {};

        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) {
            params[key] = value;
        });

        return params;
    },

    /**
     * URL Param 파싱
     */
    getUrlParamsToString: function() {
        var params = "";

        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) {
            params += key + "=" + value + "&";
        });

        if(params.length > 0){
            params.substr(0, params.length - 2);
        }

        return params;
    },

    /**
     * URL Param 파싱
     */
    getObjectToParamString: function(obj) {
        var params = "";

        Object.keys(obj).map(function (key) {

            // 검색키워드
            if(key == 'searchKeyword') {
                params += key + "=" + encodeURIComponent(obj[key]) + "&";
            }else{
                params += key + "=" + obj[key] + "&";
            }
        });

        if(params.length > 0){
            params = params.substr(0, params.length - 1);
        }

        return params;
    },

    /**
     * 문자를 integer로 변환
     * str : 숫자, 문자열
     */
    toInt: function(str) {
        var type = typeof str;

        if (type === "string" || type === "number") {
            var temp = this.trim(str) + "";

            if (temp != "" && !isNaN(temp)) {
                return parseInt(temp, 10);
            }
        }

        return 0;
    },

    /**
     * 숫자 구하기
     * str : 문자열
     */
    toNumber: function(str) {
        if (typeof str === "string") {
            var symbol = "";

            // 음수 기호 구하기
            if (str.indexOf("-") == 0) {
                symbol = "-";
            }

            return symbol + str.replace(/[^0-9]+/g, "");
        }

        return str;
    },

    /**
     * 로그인 페이지 이동
     */
    onLoginMove: function() {
        window.location.href = "/m/login?callbackUrl=" + encodeURIComponent(window.location.href);
    },

    /**
     * Session Storage 값 조회
     */
    getStorageData: function(key, useCache) {
        var nowTime = new Date().getTime();
        var dataObj = JSON.parse(window.sessionStorage.getItem(key));

        if (dataObj == null) {
            return null;
        }

        if (useCache !== undefined && useCache == false) {
            return dataObj;
        } else {
            if (dataObj['expireTime'] != null && nowTime < dataObj['expireTime']) {
                return dataObj;
            } else {
                return null;
            }
        }
    },

    /**
     * Session Storage 값 설정
     */
    setStorageData: function(key, obj, useCache){
        var expireTime = new Date();

        if (useCache === undefined || useCache != false) {
            expireTime.setMinutes(expireTime.getMinutes() + 120);

            obj['expireTime'] = expireTime.getTime();
        }

        window.sessionStorage.setItem(key, JSON.stringify(obj));
    },

    removeStorageData: function(key) {
        window.sessionStorage.removeItem(key);
    },
    
    clearStorageData: function() {
        window.sessionStorage.clear();
    },

    /**
     * User Agent
     */
    getUA: function(){
        return navigator.userAgent;
    },

    /**
     * 문자 byte 구하기
     */
    getTextLength: function(str) {
        var len = 0;

        for (var i = 0; i < str.length; i++) {
            if (escape(str.charAt(i)).length == 6) {
                len++;
            }

            len++;
        }

        return len;
    },

    /**
     * 문자열을 최대 길이에 맟춰 자른다.
     * @param str
     * @param maxBytes
     * @returns {string}
     */
    cutByte: function(str, maxBytes) {
        var c,i;
        for (var b = i = 0; c = str.charCodeAt(i);) {
            b += c >> 7 ? 2 : 1;
            if (b > maxBytes) {
                break;
            }
            i++;
        }
        return str.substring(0,i);
    },

    /**
     * 배열 체크
     */
    isEmptyList: function(arr) {
        var type = typeof arr;

        if (!arr || type === "undefined" || arr === null) {
            return true;
        }

        if (type !== 'object') {
            return true;
        }

        if (arr.length > 0) {
            return false;
        }

        return true;
    },

    /**
     * 상단 버튼
     */
    btnTop: function(opt) {
        if (!this.isObject(opt)) {
            opt = {};
        }

        // 체크 상단
        var chkTop = this.toInt(opt.chkTop);

        if (chkTop == 0) {
            chkTop = 200;
        }

        // 버튼 오른쪽 위치
        var right = this.toInt(opt.right);

        if (right == 0) {
            right = 10;
        }

        // 버튼 하단 위치
        var bottom = this.toInt(opt.bottom);

        if (bottom == 0) {
            bottom = 10;
        }

        // top 버튼
        var btnTopElmt = DocUtil.getElById("btnGblTop");

        DocUtil.css(btnTopElmt, {
            right: right + "px",
            bottom: "-50px"
        });

        // 스크롤 이벤트
        window.addEventListener("scroll", function() {
            var winTop = window.pageYOffset;

            if (winTop > chkTop) {
                if (btnTopElmt.style.opacity == 0) {
                    btnTopElmt.style.bottom = bottom + "px";
                    btnTopElmt.style.opacity = 1;
                }
            } else {
                if (btnTopElmt.style.opacity == 1) {
                    btnTopElmt.style.bottom = "-50px";
                    btnTopElmt.style.opacity = 0;
                }
            }
        }, false);
    },

    /**
     * 이미지 방향 구하기
     * 1:0도, 3:180도, 6:270도, 8:90도
     */
    getImgOrient: function(file, callback) {
        var reader = new FileReader();
        reader.onload = function(e) {
            var view = new DataView(e.target.result);

            if (view.getUint16(0, false) != 0xFFD8) {
                return callback(-2);
            }

            var length = view.byteLength, offset = 2;

            while (offset < length) {
                if (view.getUint16(offset + 2, false) <= 8) {
                    return callback(-1);
                }

                var marker = view.getUint16(offset, false);
                offset += 2;

                if (marker == 0xFFE1) {
                    if (view.getUint32(offset += 2, false) != 0x45786966) {
                        return callback(-1);
                    }

                    var little = view.getUint16(offset += 6, false) == 0x4949;
                    offset += view.getUint32(offset + 4, little);
                    var tags = view.getUint16(offset, little);
                    offset += 2;

                    for (var i = 0; i < tags; i++) {
                        if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                            return callback(view.getUint16(offset + (i * 12) + 8, little));
                        }
                    }
                } else if ((marker & 0xFF00) != 0xFF00) {
                    break;
                } else {
                    offset += view.getUint16(offset, false);
                }
            }

            return callback(-1);
        };
        reader.readAsArrayBuffer(file);
    },

    /**
     * 이미지 회전 구하기
     * orient : 회전정보
     */
    getImgRotate: function(orient) {
        var rotate = 0;

        // 180도 회전
        if (orient == 3) {
            rotate = 180;

        // 90도 회전
        } else if (orient == 6) {
            rotate = 90;

        // 270도 회전
        } else if (orient == 8) {
            rotate = 270;
        }

        return rotate;
    },

    alert: function(content, title) {
        store.commit(types.ALERT_TITLE  , title);
        store.commit(types.ALERT_CONTENT, content);
        store.commit(types.ALERT_DIALOG , true);
    },

    setCookie :  function (name, value, expire){
        var todayValue = new Date();
        todayValue.setDate(todayValue.getDate() + expire);

        document.cookie = name + "=" + encodeURI(value) + "; expires=" + todayValue.toGMTString() + "; path=/;";
    },

    getCookie : function getCookie(name) {
        var cookieName = name + "=";
        var x = 0;

        while ( x <= document.cookie.length ) {
            var y = (x+cookieName.length);
            if (document.cookie.substring( x, y ) == cookieName) {
                if ((lastChrCookie = document.cookie.indexOf(";", y)) == -1)
                    lastChrCookie = document.cookie.length;
                return decodeURI(document.cookie.substring(y, lastChrCookie));
            }
            x = document.cookie.indexOf(" ", x ) + 1;
            if ( x == 0 )
                break;
        }
        return "";
    },

    pad : function(n, width) {
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
    }, 

    appSetting : function(userId, userPw, rtnData){
        if(isApp()){
            if(isAndroidApp()){
                window.HybridApp.setAppLoginId      (userId);
                window.HybridApp.setAppLoginPwd     (userPw);
//                window.HybridApp.setMaskingId       (rtnData.maskingId);
//                window.HybridApp.setMemTypCd        (rtnData.memTypCd);
//                window.HybridApp.setSnsType         (rtnData.snsType);
//                window.HybridApp.setAppPushYn       (rtnData.appPushYn);
//                window.HybridApp.setAppPushEtiquetYn(rtnData.appPushEtiquetYn);
//                window.HybridApp.setJwtToken        (rtnData.jwtToken);
            }else{
                //ios처리
                window.webkit.messageHandlers.setAppLoginId.postMessage(rtnData.userId);
                window.webkit.messageHandlers.setMaskingId.postMessage(rtnData.maskingId);
                window.webkit.messageHandlers.setMemTypCd.postMessage(rtnData.memTypCd);
                window.webkit.messageHandlers.setSnsType.postMessage(rtnData.snsType);
                window.webkit.messageHandlers.setAppPushYn.postMessage(rtnData.appPushYn);
                window.webkit.messageHandlers.setAppPushEtiquetYn.postMessage(rtnData.appPushEtiquetYn);
                window.webkit.messageHandlers.setJwtToken.postMessage(rtnData.jwtToken);  
            }
        }
    },

    /**
     * 특수문자 제거 함수.
     * @param str
     * @returns {string}
     */
    filterSpecialChar: function(str) {
        const regex = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
    
        if (str.length > 0) {
            return str.replace(regex, ''); // 특수문자만 제거
        }
        return str;
    },

    // 숫자만 추리기
    extractNumbers(input) {
        let numbersOnly = '';
        if ( WebUtil.isNotNull(input) ) {
            numbersOnly = input.replace(/\D/g, '');
        }
        return numbersOnly;
    },
}
